import React from 'react';
import { Switch, Tooltip, Space } from 'antd';
import { SunOutlined, MoonOutlined, BulbOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Tooltip title={theme === 'light' ? 'فعال کردن حالت تاریک' : 'فعال کردن حالت روشن'}>
      <Switch
        checked={theme === 'dark'}
        onChange={toggleTheme}
        checkedChildren={<MoonOutlined />}
        unCheckedChildren={<SunOutlined />}
        className="theme-toggle-switch"
      />
    </Tooltip>
  );
};

export default ThemeToggle;

